import type ModalService from "./modalService";
import type LustrationProcessedViewModel from "viewModels/enforcement/lustrationReports/lustrationProcessedViewModel";
import type LustrationFinishedViewModel from "viewModels/enforcement/lustrationReports/lustrationFinishedViewModel";

export default class LustrationReportsService {
  constructor(
    private modalService: ModalService,
    private lustrationProcessedViewModelFactory: ReturnType<typeof LustrationProcessedViewModel.Factory>,
    private lustrationFinishedViewModelFactory: ReturnType<typeof LustrationFinishedViewModel.Factory>
  ) {}

  public async showProcessedConfirmation() {
    const viewModel = this.lustrationProcessedViewModelFactory();
    await this.modalService.tryActivateChild(viewModel);
    const { confirmed, generate } = await viewModel.showConfirmation();
    this.modalService.closeChild(viewModel);
    return { confirmed, generate };
  }
  public async showFinishedConfirmation() {
    const viewModel = this.lustrationFinishedViewModelFactory();
    await this.modalService.tryActivateChild(viewModel);
    const { confirmed, generate } = await viewModel.showConfirmation();
    this.modalService.closeChild(viewModel);
    return { confirmed, generate };
  }
}
